import React from "react";
import { MessageCircle, Mail, Users, Settings2 } from "lucide-react";
import MerkezHubShell from "@/components/MerkezHubShell";

const TABS = [
    { id: "whatsapp", label: "WhatsApp", icon: MessageCircle },
    { id: "eposta", label: "E-posta", icon: Mail },
    { id: "muvekkil", label: "Müvekkil Portal", icon: Users },
    { id: "ayar", label: "Portal Ayarları", icon: Settings2 },
];

export default function IletisimMerkezLayout() {
    return (
        <MerkezHubShell
            title="İletişim Merkezi"
            subtitle="WhatsApp, e-posta ve müvekkil portal mesajlaşmasını tek komutadan yönetin."
            badge="İletişim · Omnichannel"
            basePath="/yeni/iletisim-merkezi"
            tabs={TABS}
        />
    );
}
